/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'confluence-table-tree.column.contributors': 'Collaboratori',
  'confluence-table-tree.column.last-modified': 'Ultima modifica',
  'confluence-table-tree.column.title': 'Nome',
  'confluence-table-tree.could-not-load': 'Impossibile caricare',
  'confluence-table-tree.could-not-load-contributors': 'Impossibile caricare i collaboratori',
  'confluence-table-tree.create-child-page': 'Crea una pagina subordinata',
  'confluence-table-tree.create-page': 'Crea pagina',
  'confluence-table-tree.default.page.title': 'Senza titolo',
  'confluence-table-tree.default.show-all-pages-button.label': 'Mostra altre pagine',
  'confluence-table-tree.draft.lozenge': 'BOZZA',
  'confluence-table-tree.draft.tooltip': 'Solo tu puoi vedere le bozze.',
  'confluence-table-tree.drafts-toggle.label': 'Mostra bozze',
  'confluence-table-tree.edit': 'Modifica',
  'confluence-table-tree.edit-in-confluence': 'Modifica in Confluence',
  'confluence-table-tree.empty.description':
    'Crea note della riunione, requisiti di prodotto, decisioni e altri contenuti per riempire questo spazio.',
  'confluence-table-tree.empty.title': 'Non c’è niente qui, solo possibilità',
  'confluence-table-tree.error.description': 'Al momento non possiamo mostrarti queste pagine. Riprova più tardi.',
  'confluence-table-tree.error.row': 'Impossibile caricare le pagine.',
  'confluence-table-tree.error.title': 'È imbarazzante...',
  'confluence-table-tree.friendly-when-created': 'Creati',
  'confluence-table-tree.friendly-when-updated': 'Aggiornato',
  'confluence-table-tree.share.copied': 'Copiato negli appunti',
  'confluence-table-tree.share.copy-button': 'Copia',
  'confluence-table-tree.share.subtitle': 'Condividi questo link',
  'confluence-table-tree.share.title': 'Condividi pagina',
  'confluence-table-tree.share.tooltip': 'Condividi',
  'confluence-table-tree.view-profile': 'Visualizza profilo',
};
